import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Link,
  Switch,
  DarkMode,
  Select,
  Checkbox,
  useToast,
} from "@chakra-ui/react";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";
import useApiReq from "variables/apireq";
import { Loader } from "components/Loader/loader";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useLoader } from "components/Loader/loader";

function UpdatePackages() {
  const titleColor = "white";
  const [error, setError] = useState(null);
  const [packages, setPackages] = useState([]);
  const { setIsLoading, isLoading } = useLoader();
  const [formData, setFormData] = useState({});
  const toast = useToast({ position: "top" });
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const fetchPackages = async () => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "package/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setPackages(res.response);
        if (searchParams.get("uuid")) {
          const pack = res.response.find(
            (item) => item.uuid === searchParams.get("uuid")
          );
          setFormData({
            pack: pack.uuid,
            name: pack.name,
            duration: pack.duration,
            price: pack.price,
            type: pack.type,
            prnumber: pack.prnumber,
            facebook: pack.is_facebook,
            youtube: pack.is_youtube,
            instagram: pack.is_instagram,
            estimatedReader: pack.estimated_reader,
          });
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "pack") {
      const pack = packages.find((item) => item.uuid === value);
      setFormData({
        pack: pack.uuid,
        name: pack.name,
        duration: pack.duration,
        price: pack.price,
        type: pack.type,
        prnumber: pack.prnumber,
        facebook: pack.is_facebook,
        youtube: pack.is_youtube,
        instagram: pack.is_instagram,
        estimatedReader: pack.estimated_reader,
      });
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleEmptyFields = () => {
    setFormData((prev) =>
      Object.fromEntries(
        Object.entries(prev).filter(([_, value]) => value && value.length > 0)
      )
    );
  };
  const updatePackage = async (data) => {
    setError(null);

    setIsLoading(true);
    const res = await useApiReq({
      method: "PATCH",
      url: "package/update/" + formData.pack,
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        accept: "application/json",
      },
    });
    try {
      if (res.response) {
        toast({
          title: "Package Updated",
          description: "Package has been updated successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setFormData({
          name: "",
          duration: "",
          price: "",
          type: "PR",
          prnumber: "",
          facebook: false,
          youtube: false,
          instagram: false,
          estimatedReader: "",
        });
        history.push(
          `/${localStorage.getItem("group").toLowerCase()}/packages/list`
        );
      }
    } catch (err) {
      setError(res.error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      name: formData.name,
      duration: formData.duration,
      price: formData.price,
      type: formData.type,
      prnumber: formData.prnumber,
      is_facebook: formData.facebook,
      is_youtube: formData.youtube,
      is_instagram: formData.instagram,
      estimated_reader: formData.estimatedReader,
    };
    updatePackage(data);
  };
  if (isLoading) {
    return <div></div>;
  }
  return (
    <>
      {isLoading && <Loader />}
      <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
        <Grid templateColumns={{ sm: "1fr", lg: "60% 38%" }}>
          {/* Form */}
          <Card p="16px">
            <CardHeader>
              <Flex
                justify="space-between"
                align="center"
                minHeight="60px"
                w="100%"
              >
                <Text fontSize="lg" color="#fff" fontWeight="bold">
                  Packages Update
                </Text>
              </Flex>
            </CardHeader>
            <CardBody>
              <Flex
                justify="space-between"
                align="center"
                minHeight="60px"
                w="100%"
              >
                <GradientBorder
                  p="2px"
                  ml={{ base: "0px", lg: "24px" }}
                  w="100%"
                  me={{ base: "none", lg: "30px", xl: "none" }}
                  background="transparent"
                  boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
                  borderRadius="30px"
                >
                  <Flex
                    background="transparent"
                    borderRadius="30px"
                    direction="column"
                    p="40px"
                    minW={{ base: "unset", md: "430px", xl: "450px" }}
                    w="100%"
                    mx={{ base: "0px" }}
                    bg={{
                      base: "rgba(19,21,56,.5)",
                    }}
                  >
                    <FormControl>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Package
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          disabled={searchParams.get("uuid")}
                          _disabled={{
                            color: "white",
                            base: "rgb(19,21,54)",
                            background: "rgb(19,21,54)",
                            backgroundColor: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="Package"
                          name="pack"
                          value={formData.pack}
                          onChange={handleChange}
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                        >
                          {packages.map((item) => (
                            <option value={item.uuid} key={item.uuid}>
                              {item.name}-{item.type}-{item.prnumber}
                            </option>
                          ))}
                        </Select>
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Name{" "}
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="Package Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Duration In Days
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="number"
                          placeholder="Duration"
                          name="duration"
                          value={formData.duration}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        PR Number
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="PR Number"
                          name="prnumber"
                          value={formData.prnumber}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Type
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="Type"
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                        >
                          <option value="PR" selected>
                            PR
                          </option>
                          <option value="ANALYTIC PR">ANALYTIC PR</option>
                          <option value="CONTENT PR">CONTENT PR</option>
                        </Select>
                      </GradientBorder>

                      <Flex
                        justify="space-between"
                        align="center"
                        mb="24px"
                        ml="16px"
                      >
                        <Checkbox
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          borderRadius="20px"
                          fontSize="sm"
                          size="md"
                          variant="subtle"
                          colorPalette="blue"
                          w={{ base: "100%", lg: "100%" }}
                          name="facebook"
                          isChecked={formData.facebook}
                          onChange={handleChange}
                        >
                          Facebook
                        </Checkbox>

                        <Checkbox
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          borderRadius="20px"
                          fontSize="sm"
                          size="md"
                          variant="subtle"
                          colorPalette="blue"
                          w={{ base: "100%", lg: "100%" }}
                          name="youtube"
                          isChecked={formData.youtube}
                          onChange={handleChange}
                        >
                          Youtube
                        </Checkbox>
                        <Checkbox
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          borderRadius="20px"
                          fontSize="sm"
                          size="md"
                          variant="subtle"
                          colorPalette="blue"
                          name="instragram"
                          isChecked={formData.instagram}
                          onChange={handleChange}
                          w={{ base: "100%", lg: "100%" }}
                        >
                          Instragram
                        </Checkbox>
                      </Flex>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Estimated Reader
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="number"
                          placeholder="Estimated Reader"
                          name="estimatedReader"
                          value={formData.estimatedReader}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Price
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="number"
                          placeholder="Price"
                          name="price"
                          value={formData.price}
                          onChange={handleChange}
                        />
                      </GradientBorder>

                      <Button
                        variant="brand"
                        fontSize="1.2rem"
                        type="submit"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="45px"
                        mb="20px"
                        mt="20px"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </Flex>
                </GradientBorder>
              </Flex>
            </CardBody>
          </Card>

          {/* Preview */}
          <Card
            p="22px"
            my={{ sm: "24px", lg: "0px" }}
            ms={{ sm: "0px", lg: "24px" }}
          >
            <Flex direction="column">
              <CardHeader py="12px">
                <Text color="#fff" fontSize="lg" fontWeight="bold">
                  Preview
                </Text>
              </CardHeader>
              <CardBody>
                <Flex direction="column" w="100%">
                  {Object.entries(formData).map(([key, value]) =>
                    key === "pack" ? null : value ? (
                      <Text
                        key={key}
                        color="#fff"
                        fontSize="lg"
                        fontWeight="500"
                        style={{
                          textTransform: "capitalize",
                          marginBottom: "10px",
                        }}
                      >
                        {key.replace(/([A-Z])/g, " $1")}:{" "}
                        {typeof value === "boolean"
                          ? value
                            ? "Yes"
                            : "No"
                          : value}
                      </Text>
                    ) : null
                  )}
                </Flex>
              </CardBody>
            </Flex>
          </Card>
        </Grid>
      </Flex>
    </>
  );
}

export default UpdatePackages;
